module.exports = __webpack_public_path__ + "static/media/img1.b7d007cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/img1.png
// module id = 568
// module chunks = 0